var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"group"},_vm._l((_vm.field.items),function(groupField){return _c('configField',{key:_vm.getFieldData(groupField.id)['FieldId'],attrs:{"id":_vm.id,"category":_vm.category,"field":_vm.getFieldData(groupField.id),"value":_vm.getConfigValue(groupField.id),"hideLabel":"","hideTooltip":"","parentField":_vm.parentField}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }